import { Component } from '@angular/core';
import { NotificationService } from './core/notification.service';
import { NotificationComponent } from './core/notification.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { filter, map, startWith } from 'rxjs/operators';
import { NavigationEnd, RouteConfigLoadEnd, RouteConfigLoadStart, Router } from '@angular/router';
import { LoaderService } from './core/loader.service';
import { environment } from '../environments/environment';
import { Observable } from 'rxjs';
import { QuickGuideVisibilityService } from './shared/quick-guide/quick-guide-visibility.service';

@Component({
  selector: 'app-root',
  standalone: false,
  template: `
    <app-tour-step-template *ngIf="quickGuideEnabled"></app-tour-step-template>
    <router-outlet></router-outlet>
    <app-floating-toc *ngIf="quickGuideEnabled && (isMainRoute$ | async)"></app-floating-toc>
    <ng-container *ngIf="notification$ | async"></ng-container>
  `,
})
export class AppComponent {
  title = 'baltec-gui';
  quickGuideEnabled = this.quickGuideVisibilityService.isEnabled();
  notification$ = this.notificationService.notification$.pipe(
    filter((notification) => notification && notification.message.length > 0),
    map((notification) => {
      if (notification.configuration?.severity === 'error' || notification.configuration?.severity === 'warning') {
        this.snackBar.openFromComponent(NotificationComponent, {
          ...notification.configuration,
          data: notification,
          announcementMessage: notification.message,
        });
      } else {
        this.snackBar.open(notification.message, notification.action, notification.configuration);
      }
    }),
  );
  loading$ = this.loaderService.loading$;
  isMainRoute$!: Observable<boolean>;

  constructor(private notificationService: NotificationService,
              private snackBar: MatSnackBar,
              private router: Router,
              private loaderService: LoaderService,
              private quickGuideVisibilityService: QuickGuideVisibilityService) {
    this.isMainRoute$ = this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd),
      map((event) => event.urlAfterRedirects.startsWith('/main')),
      startWith(this.router.url.startsWith('/main')),
    );

    router.events.subscribe(event => {
      if (event instanceof RouteConfigLoadStart) {
        this.loaderService.loading$.next(true);
      }
      else if (event instanceof RouteConfigLoadEnd) {
        this.loaderService.loading$.next(false);
      }
    });

    console.log('BE: ' + environment.beVersion);
    console.log('FE: ' + environment.feVersion);
  }
}
